import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { TranslationNS, TranslationNS_Admin } from '@gokrew/models/constants';

const namespaces = [
  ...Object.values(TranslationNS_Admin),
  TranslationNS.validations,
  TranslationNS.TwoFactor,
];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    ns: namespaces,
    defaultNS: TranslationNS_Admin.Auth,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
